import { atom } from "jotai";

const lzSAuthLoadedAtom = atom<boolean>(false);

export default lzSAuthLoadedAtom;
